import React from "react";
import { Link } from "react-router-dom";

const ConditionalLink = ({
    to,
    condition,
    children,
    className = "",
    onClick = () => {},
}) => {
    const getChildren = () => {
        if (!condition && className)
            return <div className={className}>{children}</div>;

        return children;
    };

    return condition ? (
        <Link to={to} className={className} onClick={onClick}>
            {children}
        </Link>
    ) : (
        getChildren()
    );
};

export default ConditionalLink;
